<label for="chip-{{name}}">{{name}}</label>
<div class="input-group">
  <select class="custom-select" id="chip-{{name}}" [(ngModel)]="value">
    <option *ngFor="let inspector of inspectorList" [value]="inspector.user">{{inspector.name}}</option>
  </select>
  <div class="input-group-append">
    <button class="btn btn-primary" type="button" (click)="add()">Add</button>
  </div>
</div>
<app-chip [chips]="values" (removeEvent)="onRemove($event)"></app-chip>
